fx.ns("filters.photofilters", class SaturateFilter extends filters.photofilters.BaseFilter {
    
    constructor(parameters)
    {
        super(parameters);

        this.amount = this.params.amount;
        
    };

  
	filterFCN(add)
	{
    	 add.colorMatrix('saturate', this.amount)
        
	}


});
